import { useState } from "react";
import { videos } from "@/mocks/videos";
import VideoCard from "@/components/feature/VideoCard";

const tabs = [
  { id: "all", label: "全部" },
  { id: "stars", label: "明星动态" },
  { id: "variety", label: "综艺片段" },
  { id: "film", label: "影视花絮" },
  { id: "red", label: "红人视频" },
];

export default function VideoFeed() {
  const [active, setActive] = useState("all");
  const list = active === "all" ? videos : videos.filter((v) => v.categoryId === active);

  return (
    <section id="feed" className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">Fresh</p>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            今日圈内速递
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            实时聚合最新热点视频，按栏目随心切换，新鲜瓜第一时间端上来。
          </p>
        </div>
        <div
          className="inline-flex items-center gap-1 rounded-full bg-background-100 p-1 ring-1 ring-inset ring-background-200"
          role="tablist"
          aria-label="栏目切换"
        >
          {tabs.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={active === t.id}
              onClick={() => setActive(t.id)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition ${
                active === t.id
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {list.map((v) => (
          <VideoCard key={v.id} video={v} />
        ))}
      </div>
    </section>
  );
}